import type { RootState } from '@app/types';

export const getDownloadGenerateFile = (state: RootState) => state.downloadGenerate.file;
